export const requestTimeout = (ms: number) => {
  return new Promise<never>((_, reject) =>
    setTimeout(() => reject(new Error("Request timed out")), ms),
  );
};
